<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :has-add="!(isOREAdvancedFilter && showAdvancedOREFilter)"
          :actions="headerActionConfig"
          :has-return="true"
          :page="page"
          @onAdd="$router.push({ name: 'AddCertificationDiscipline' })"
          @onReturn="$router.push({ name: 'student-menu' })"
        />
      </div>
    </div>
    <div
      v-if="showCertificationPanel"
      class="generate-certification-panel d-flex flex-column bg-secondary-3 rounded mx-2"
    >
      <div class="col-12 p-0">
        <icon-view
          :has-border="false"
          icon="fas fa-plus-circle text-orange circle-icon"
          icon-size="20px"
          icon-background="white"
          title="Generar Certificaciones ORE"
          variant="custom-icon-view"
        />
      </div>
      <validation-observer
        ref="formCertificationPanel"
        tag="form"
        class="generate-certification-filters d-flex justify-content-start align-items-start row mx-auto col-12 p-0"
        novalidate
      >
        <validation-provider
          v-slot="{ errors }"
          name="academicYearFilter"
          rules="required"
          class="col-12 col-md-4 p-0"
        >
          <custom-drop-down
            v-model="generateCertificationsFilterModel.academicYear"
            label="Año Académico:"
            label-class="filter-label font-14 color-secondary-6"
            placeholder="Seleccione"
            required="required"
            fieldkey="id"
            fieldname="name"
            :options="academicYearsOptions"
            :error="errors[0]"
            custom-error-msg="Favor de seleccionar el año académico."
          />
        </validation-provider>
        <validation-provider
          v-slot="{ errors }"
          name="centerFilter"
          rules="required"
          class="col-12 col-md-4 p-0"
        >
          <custom-drop-down
            v-model="generateCertificationsFilterModel.center"
            label="CSEE/ORE:"
            label-class="filter-label font-14 color-secondary-6"
            placeholder="Seleccione"
            required="required"
            fieldkey="id"
            fieldname="name"
            :options="centerOptions"
            :error="errors[0]"
            custom-error-msg="Favor de seleccionar la región o ORE."
          />
        </validation-provider>
      </validation-observer>
      <div class="d-flex justify-content-end align-items-end col-12 p-0">
        <action-button
          type="button"
          text="Cancelar"
          i="fas fa-times-circle"
          variant="outline-danger"
          @click="hideCertificationPanel"
        />
        <action-button
          type="button"
          text="Crear Certificación"
          i="fas fa-file-plus"
          variant="success ml-2"
          @click="onGenerateCertification"
        />
      </div>
    </div>
    <div class="mx-2 mt-4">
      <filter-manager
        :display-advanced="false"
        :filters-header="filtersHeader"
        actions-container-class="mx-0 px-1"
        @search="onSearch"
        @academicYear="
          updateFiltersData('academicYear', $event, 'onAcademicYearChanged')
        "
        @region="updateFiltersData('region', $event, 'onRegionChanged')"
        @center="updateFiltersData('center', $event, 'onCenterChanged')"
        @municipality="
          updateFiltersData('municipality', $event, 'onMunicipalityChanged')
        "
        @school="updateFiltersData('school', $event, 'onSchoolChanged')"
        @status="updateFiltersData('status', $event, 'onStatusChanged')"
      >
        <div
          v-if="showAdvancedOREFilter"
          slot="prior"
          class="certification-button-switch d-flex row mx-auto align-items-center item-flex flex-grow-1 col-12 col-md px-1"
        >
          <action-button
            type="button"
            text="Escuelas"
            :variant="getSwitchFilterStyles(schoolCertificationFilter.SCHOOL)"
            class="font-weight-bold school-switch-button switch-switch-button col px-0 text-nowrap"
            @click="switchCertificationFilter(schoolCertificationFilter.SCHOOL)"
          />
          <action-button
            type="button"
            text="CSEE/ORE"
            :variant="getSwitchFilterStyles(schoolCertificationFilter.CSEE)"
            class="font-weight-bold csee-switch-button switch-switch-button col px-0 text-nowrap"
            @click="switchCertificationFilter(schoolCertificationFilter.CSEE)"
          />
        </div>
      </filter-manager>
    </div>
    <div
      class="container-progress p-3 ml-2 mr-2 mt-5"
      v-if="isOREAdvancedFilter"
    >
      <div class="row">
        <div class="col-4">
          <div class="container-progress-quantity m-3">
            <div class="row">
              <div class="col-3">
                <RingProgressIndicator
                  class="pt-5 pb-5 pl-5"
                  :percentage="progressCounter.pendingPercent"
                  ringColor="orange"
                  :size="80"
                />
              </div>
              <div class="col-6 pt-2">
                <p class="pt-2">Pendientes</p>
                <h5 class="">
                  {{ progressCounter.pending | thousandsSeparator }}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="container-progress-quantity m-3">
            <div class="row">
              <div class="col-3">
                <RingProgressIndicator
                  class="pt-5 pb-5 pl-5"
                  :percentage="progressCounter.completePercent"
                  ringColor="orange"
                  :size="80"
                />
              </div>
              <div class="col-6 pt-2">
                <p class="pt-2">Completados</p>
                <h5 class="">
                  {{ progressCounter.complete | thousandsSeparator }}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="container-progress-quantity m-3">
            <p class="pt-4 pl-5">Total de Certificación de Disciplina</p>
            <h5 class="pl-5">
              {{ progressCounter.total | thousandsSeparator }}
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt-4 pb-2">
      <div class="col-12">
        <div class="custom-separator-title">
          <CustomSeparator :text="page.separator" />
        </div>
      </div>
    </div>
    <div
      class="row pt-4 pb-2"
      v-if="
        this.IsSubjected &&
          !isOREAdvancedFilter &&
          showAdvancedOREFilter &&
          !!results.length
      "
    >
      <div class="col-10"></div>
      <div class="col-2">
        <div
          class="row"
          :class="{
            'align-end-selected': isSelected,
            'align-end': !isSelected,
          }"
        >
          <div class="col-2">
            <check-box
              class="mt-1"
              v-model="isSelected"
              :value="isSelected"
              :disabled="false"
              :label="'pss'"
              name="studentFactors"
            />
          </div>
          <div class="col-10">
            <label for="" class="mt-1" :class="{ 'text-green': isSelected }">
              {{
                !isSelected
                  ? `Seleccionar todo`
                  : `Deseleccionar Todo (${selecctionQuantity})`
              }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <CustomResultNotFound
      v-if="showNotResults"
      class="mt-4 row pt-3"
      text="No hay información disponible."
    />

    <div v-else class="mt-4">
      <template v-if="isOREAdvancedFilter">
        <row-child-count-ore
          v-for="(item, index) in oreResults"
          :index="index"
          :active-index="activeIndex"
          :key="`RowChildCountOre${index}`"
          class="mb-3"
          :show-region-label="showRegionLabel"
          :messages="messages"
          :option="item"
          @on-set-active-index="activeIndex = $event"
          @update-row-result="onUpdateRowResult"
        />
      </template>
      <template v-else>
        <row-child-count
          v-for="(item, index) in results"
          :key="`RowChildCount${index}`"
          class="mb-3"
          :messages="messages"
          :options="item"
          :on-action-completed="search"
          @individualCheckValue="getIndividualcheckValue"
          @returnStatus="search()"
        />
      </template>
      <div v-if="isOREAdvancedFilter" class="row mx-auto">
        <div class="col-12 p-0">
          <Pagination
            id="pgChildCountOreHistory"
            :show-text="true"
            :data="orePagination"
            @pagination-go-page="goToOrePage"
          />
        </div>
      </div>
      <div v-else class="row mx-auto p-0">
        <div class="col-12">
          <Pagination
            id="pgChildCountHistory"
            :show-text="true"
            :data="pagination"
            @pagination-go-page="goToPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/common/page/PageHeader';
import CustomSeparator from '@/components/common/CustomSeparator';
import CustomResultNotFound from 'custom-result-not-found';
import FilterManager from '@/components/common/FilterCustomManager';
import RowChildCount from '@/components/student/disciplineCertification/RowChildCount';
import RowChildCountOre from '@/components/student/disciplineCertification/RowChildCountOre';
import ResourcesService from '@/services/resources.js';
import Pagination from '@/components/common/Pagination';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import CustomDropDown from '@/components/common/CustomDropDown';
import mixAlert from '@/mixin/alert.mixin';
import locationServices from '@/services/api/location.api';
import disciplineServices from '@/services/api/disciplineCertification.api';
import {
  validateCertificationExistence as _validateCertificationExistence,
  createOreCertification as _createOreCertification,
  getCentersWithoutCertification as _getCentersWithoutCertification,
  searchOreCertifications as _searchOreCertifications,
} from '@/services/api/certificationOre.api';
import statusEnum from '@/utils/constants/student/childCountStatusEnum';
import mixin from '@/mixin/storeGenerator';
import CheckBox from 'CheckBox';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

import RingProgressIndicator from '@/components/common/RingProgressIndicator';

import certificationTypes from '@/utils/constants/certificationTypes';

const ROUTE_NAME_FROM = 'student';
const SwitchCertificationFilter = {
  SCHOOL: 1,
  CSEE: 2,
};

export default {
  name: 'DisciplineCertification',
  mixins: [mixAlert, mixin],
  components: {
    PageHeader,
    RowChildCount,
    RowChildCountOre,
    CustomSeparator,
    FilterManager,
    Pagination,
    ActionButton,
    CheckBox,
    IconView,
    CustomDropDown,
    ValidationProvider,
    ValidationObserver,
    RingProgressIndicator,
    CustomResultNotFound,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-circle',
        title: 'Certificación de Disciplina',
        routes: ['Inicio', 'Estudiante', 'Certificación de Disciplina'],
        separator: 'Resultados',
      },
      isOpenAdvanced: false,
      messages: [],
      collections: {
        academicYears: [],
        regions: [],
        status: [],
        centers: [],
        municipalities: [],
        schools: [],
      },
      filters: {
        academicYear: null,
        region: null,
        center: null,
        municipality: null,
        school: null,
        status: null,
      },
      results: [],
      oreResults: [],
      pagination: {
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 1,
        count: 0,
        pageSize: 10,
      },
      orePagination: {
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 1,
        count: 0,
        pageSize: 10,
      },
      regionDisabled: false,
      centerDisabled: false,
      municipalityDisabled: false,
      schoolDisabled: false,
      switchFilter: SwitchCertificationFilter.SCHOOL,
      isSelected: false,
      selecctionQuantity: false,
      showCertificationPanel: false,
      generateCertificationsFilterModel: {
        academicYear: null,
        center: null,
      },
      academicYearsOptions: [],
      centerOptions: [],
      progress: null,
      filteredByCenterFlag: false,
      activeIndex: null,
      totalSelect: null,
      IsSubjected: false,
      currentStatusSearch: null,
    };
  },
  beforeRouteEnter(_, from, next) {
    next((vm) => {
      if (!vm.$store.state[vm.moduleName] || from.name == ROUTE_NAME_FROM) {
        vm.dispose();
      }
    });
  },
  async mounted() {
    this.isOpenAdvanced = this.userRegions != null;
    this.messages = await ResourcesService.LoadValidationMessages([
      '0312',
      '0675',
      'R90020',
      'R150005',
      'R150006',
      'R150007',
    ]);
    this.selecctionQuantity = 0;
    await this.initFilters();
  },
  async destroyed() {
    this.results = [];
    this.isSelected = false;
    let filterProperties = {
      AcademicYearId: this.filters.academicYear
        ? this.filters.academicYear.id
        : null,
      RegionId: null,
      MunicipalityId: null,
      SchoolId: null,
      StatusId: null,
      PageIndex: this.pagination.currentPage,
      PageSize: this.pagination.pageSize,
    };
    this.currentStatusSearch = filterProperties.StatusId;
    await disciplineServices.markAllToChangeStatus(filterProperties, false);
    this.search();
    this.persistData();
  },
  methods: {
    switchCertificationFilter(switchSelection) {
      if (switchSelection === SwitchCertificationFilter.SCHOOL) {
        this.showCertificationPanel = false;
      }
      this.switchFilter = switchSelection;
    },
    openGenerateCertificationsPanel(open = true) {
      this.showCertificationPanel = open;
    },
    hideCertificationPanel() {
      this.openGenerateCertificationsPanel(false);
    },
    async onGenerateCertification() {
      const isValid = await this.$refs.formCertificationPanel.validate();

      if (!isValid) return;

      const payload = {
        academicYearId: this.generateCertificationsFilterModel?.academicYear
          ?.id,
        centerId: this.generateCertificationsFilterModel?.center?.id,
        type: certificationTypes.Discipline,
      };

      const {
        data: existAnyCertification,
      } = await _validateCertificationExistence(payload);

      if (existAnyCertification) {
        this.ShowToast(
          '',
          'No se puede crear certificación ya que hay una existente para el año seleccionado.',
          'error'
        );
        return;
      }

      const { data } = await _createOreCertification(payload);

      if (!data?.certificationOreId) return;

      this.ShowToast(
        'Proceso Existoso',
        'La Certificación se ha creado exitosamente.',
        'success'
      );
      const academicYear = this.currentAcademicYear();
      let info = await _getCentersWithoutCertification({
        academicYearId: academicYear.id,
        type: certificationTypes.Discipline,
      });
      this.centerOptions = info.data || [];
      this.generateCertificationsFilterModel.center = null;
      this.hideCertificationPanel();
      await this.searchOreCertifications();
    },
    async onSearch(args) {
      if (args == null) return;

      if (this.isOREAdvancedFilter) {
        this.orePagination.currentPage = 1;

        await this.searchOreCertifications();
      } else {
        this.pagination.currentPage = 1;

        await this.search();
      }
      this.isSelected = false;
    },
    async goToPage(pageIndex) {
      this.pagination.currentPage = pageIndex;

      await this.search();
    },
    async goToOrePage(pageIndex) {
      this.orePagination.currentPage = pageIndex;

      await this.searchOreCertifications();
    },
    async searchOreCertifications() {
      this.activeIndex = null;

      const params = {
        type: certificationTypes.Discipline,
        academicYearId: this.filters.academicYear?.id,
        centerId: this.filters.center?.id,
        statusId: this.filters.status?.id,
        pageIndex: this.orePagination.currentPage,
        pageSize: this.orePagination.pageSize,
      };

      this.filteredByCenterFlag = this.filters.center?.id;

      const { data: result } = await _searchOreCertifications(params);

      this.oreResults = [...result.data];
      this.orePagination = {
        count: result.count,
        totalItemCount: result.totalItemCount,
        pageCount: result.pageCount,
        currentPage: result.currentPage,
        totalPages: result.pageCount,
        totalRecords: result.totalItemCount,
        pageSize: 10,
      };
    },
    async search() {
      this.results = [];
      if (!this.filters.academicYear) {
        return;
      }
      let filterProperties = {
        AcademicYearId: this.filters.academicYear
          ? this.filters.academicYear.id
          : null,
        RegionId: this.filters.region ? this.filters.region.id : null,
        MunicipalityId: this.filters.municipality
          ? this.filters.municipality.id
          : null,
        SchoolId: this.filters.school ? this.filters.school.id : null,
        StatusId: this.filters.status ? this.filters.status.id : null,
        PageIndex: this.pagination.currentPage,
        PageSize: this.pagination.pageSize,
      };
      this.currentStatusSearch = filterProperties.StatusId;
      if (filterProperties.StatusId == statusEnum.submited) {
        this.IsSubjected = true;
      } else {
        this.IsSubjected = false;
      }

      if (
        filterProperties.StatusId !== statusEnum.submited &&
        this.results.length
      ) {
        disciplineServices.markAllToChangeStatus(filterProperties, false);
      }
      const { data } = await disciplineServices.getDisciplineSearchData(
        filterProperties
      );

      this.results = data.data;
      this.pagination = {
        count: data.count,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        totalPages: data.pageCount,
        totalRecords: data.totalItemCount,
        pageSize: 10,
      };
      this.currentStatusSearch = filterProperties.StatusId;
      const selection = await disciplineServices.existSelectionToChangeStatus(
        filterProperties
      );
      this.selecctionQuantity = selection.data;
      this.totalSelect = data.totalItemCount;
    },
    async updateFiltersData(key, event, callback) {
      if (event?.id != statusEnum.submited) {
        let filterProperties = {
          AcademicYearId: this.filters.academicYear
            ? this.filters.academicYear.id
            : null,
          RegionId: null,
          MunicipalityId: null,
          SchoolId: null,
          StatusId: null,
          PageIndex: this.pagination.currentPage,
          PageSize: this.pagination.pageSize,
        };
        await disciplineServices.markAllToChangeStatus(filterProperties, false);
      }

      if (event != undefined && event != null && event != '')
        this.filters[key] = event;
      //Handle Value Change
      else this.filters[key] = null; //Handle Empty selections

      if (callback != undefined) {
        if (typeof this[callback] == 'function') {
          this[callback]();
        }
      }
    },
    async loadBasicCollectionFilters() {
      this.filters.academicYear = null;
      this.resetByAcademicYear();

      const {
        data,
      } = await disciplineServices.getChildCountSearchInitialFilterValues();
      this.setFilters(data.filters);

      this.setAcademicYears(data.collections.academicYears);
      !this.isOREAdvancedFilter && this.setRegions(data.collections.regions);
      this.isOREAdvancedFilter && this.setCenters(data.collections.centers);
      !this.isOREAdvancedFilter &&
        this.setMunicipalities(data.collections.municipalities);
      !this.isOREAdvancedFilter && this.setSchools(data.collections.schools);

      this.collections.status = data.collections.status;
    },
    async initFilters() {
      const academicYear = this.currentAcademicYear();
      await this.loadBasicCollectionFilters();
      await this.loadCertificationsPanelInitFilters();
      await _getCentersWithoutCertification({
        academicYearId: academicYear.id,
        type: certificationTypes.Discipline,
      });
    },
    async loadCertificationsPanelInitFilters() {
      const academicYear = this.currentAcademicYear();

      if (!academicYear) return;

      const academicYearOption = {
        id: academicYear.id,
        name: academicYear.description,
        disabled: true,
      };

      this.academicYearsOptions = [academicYearOption];

      this.generateCertificationsFilterModel.academicYear = academicYearOption;

      const { data } = await _getCentersWithoutCertification({
        academicYearId: academicYear.id,
        type: certificationTypes.Discipline,
      });
      this.centerOptions = data || [];

      this.generateCertificationsFilterModel.center =
        data?.length === 1 ? { ...data[0], disabled: true } : null;
    },
    setFilters(data) {
      this.filters.academicYear = data.academicYear;
      this.filters.region = data.region;
      this.filters.center = data.center;
      this.filters.municipality = data.municipality;
      this.filters.school = data.school;
      this.filters.status = data.status;
    },
    async onAcademicYearChanged() {
      this.resetByAcademicYear();
      this.clearCheck();

      if (!this.filters.academicYear?.id) return;

      if (this.isOREAdvancedFilter) {
        const { data } = await locationServices.getCenters({
          academicYearId: this.filters.academicYear.id,
        });
        this.setCenters(data);

        if (data.length == 1 && data[0].selected) {
          await this.onCenterChanged();
        }

        await this.setProgress();
      } else {
        const { data } = await locationServices.getRegions({
          academicYearId: this.filters.academicYear.id,
        });
        this.setRegions(data);

        if (data.length == 1 && data[0].selected) {
          await this.onRegionChanged();
        }
      }
    },
    async onStatusChanged() {
      this.clearCheckByStatusChange();
    },
    async onSchoolChanged() {
      this.clearCheck();
    },
    async onCenterChanged() {
      this.clearCheck();
    },
    async onRegionChanged() {
      this.clearCheck();
      this.resetByRegion();
      if (this.filters.academicYear != null && this.filters.region != null) {
        const { data } = await locationServices.getMunicipalities({
          academicYearId: this.filters.academicYear.id,
          regionId: this.filters.region.id,
        });
        this.setMunicipalities(data);

        if (data.length == 1 && data[0].selected) {
          await this.onMunicipalityChanged();
        }
      } else {
        this.setMunicipalities();
      }
    },
    async onMunicipalityChanged() {
      this.clearCheck();
      this.resetByMunicipality();

      if (
        this.filters.academicYear != null &&
        this.filters.municipality != null
      ) {
        const { data } = await locationServices.getSchools({
          academicYearId: this.filters.academicYear.id,
          municipalityId: this.filters.municipality.id,
        });
        this.setSchools(data);
      } else {
        this.setSchools();
      }
    },
    setAcademicYears(data) {
      this.collections.academicYears = data;

      let selectedAcademicYear = data.find((x) => x.selected);

      if (selectedAcademicYear != undefined) {
        this.filters.academicYear = selectedAcademicYear;
      }
    },
    setRegions(data) {
      this.collections.regions = data || [];

      if (data != null && data.length == 1 && data[0].selected) {
        this.filters.region = data[0];
        this.regionDisabled = true;
      } else {
        this.regionDisabled = false;
      }
    },
    setCenters(data) {
      this.collections.centers = data || [];

      if (data != null && data.length == 1 && data[0].selected) {
        this.filters.center = data[0];
        this.centerDisabled = true;
      } else {
        this.centerDisabled = false;
      }
    },
    setMunicipalities(data) {
      this.collections.municipalities = data || [];

      if (data != null && data.length == 1 && data[0].selected) {
        this.filters.municipality = data[0];
        this.municipalityDisabled = true;
      } else {
        this.municipalityDisabled = false;
      }
    },
    setSchools(data) {
      this.collections.schools = data || [];

      if (data != null && data.length == 1 && data[0].selected) {
        this.filters.school = data[0];
        this.schoolDisabled = true;
      } else {
        this.schoolDisabled = false;
      }
    },
    resetByAcademicYear() {
      this.filters.region = null;
      this.filters.center = null;
      this.filters.municipality = null;
      this.filters.school = null;

      this.collections.regions = [];
      this.collections.centers = [];
      this.collections.municipalities = [];
      this.collections.schools = [];
    },
    resetByRegion() {
      this.filters.center = null;
      this.filters.municipality = null;
      this.filters.school = null;

      this.collections.centers = [];
      this.collections.municipalities = [];
      this.collections.schools = [];
    },
    resetByMunicipality() {
      this.filters.school = null;

      this.collections.schools = [];
    },
    dispose() {
      this.initFilters();
      this.results = [];
    },
    async getIndividualcheckValue(val) {
      let filterProperties = {
        AcademicYearId: this.filters.academicYear
          ? this.filters.academicYear.id
          : null,
        RegionId: this.filters.region ? this.filters.region.id : null,
        MunicipalityId: this.filters.municipality
          ? this.filters.municipality.id
          : null,
        SchoolId: this.filters.school ? this.filters.school.id : null,
        StatusId: this.filters.status ? this.filters.status.id : null,
      };

      const { data } = await disciplineServices.existSelectionToChangeStatus(
        filterProperties
      );
      this.selecctionQuantity = data;
    },
    async clearCheckByStatusChange() {
      if (!this.isSubjected || this.isOREAdvancedFilter) return;
      let filterProperties = {
        AcademicYearId: this.filters.academicYear
          ? this.filters.academicYear.id
          : null,
        RegionId: this.filters.region ? this.filters.region.id : null,
        MunicipalityId: this.filters.municipality
          ? this.filters.municipality.id
          : null,
        SchoolId: this.filters.school ? this.filters.school.id : null,
        PageIndex: this.pagination.currentPage,
        PageSize: this.pagination.pageSize,
      };
      const { data } = await disciplineServices.existSelectionToChangeStatus(
        filterProperties
      );
      this.selecctionQuantity = data;
    },
    async approveSelectedCertification() {
      let confirm = await this.ShowCancelModal(
        'Atención',
        `¿Está seguro desea aprobar las ${this.selecctionQuantity} certificaciones de escuela seleccionadas?`,
        'Si',
        'No'
      );

      if (!confirm) return;

      let filterProperties = {
        AcademicYearId: this.filters.academicYear
          ? this.filters.academicYear.id
          : null,
        RegionId: this.filters.region ? this.filters.region.id : null,
        MunicipalityId: this.filters.municipality
          ? this.filters.municipality.id
          : null,
        SchoolId: this.filters.school ? this.filters.school.id : null,
        StatusId: this.filters.status ? this.filters.status.id : null,
      };
      try {
        await disciplineServices.approveMultiple(filterProperties);

        this.ShowToast(
          'Completado',
          'Las certificaciones han sido aprobadas exitosamente.',
          this.toastType.Success
        );
      } catch (err) {
        this.ShowToast(err.response.data.message, '', 'error');
      }

      await this.search();
    },
    async onUpdateRowResult() {
      await this.searchOreCertifications();
    },
    async setProgress() {
      this.progress = null;
      if (!this.filters?.academicYear?.id) {
        return;
      }
      const { data: progressData } = await disciplineServices.getProgress(
        this.filters?.academicYear?.id
      );
      this.progress = progressData;
    },
    async clearCheck() {
      this.isSelected = false;
      if (!this.isSubjected || this.isOREAdvancedFilter) return;
      let filterProperties = {
        AcademicYearId: this.filters.academicYear
          ? this.filters.academicYear.id
          : null,
        RegionId: this.filters.region ? this.filters.region.id : null,
        MunicipalityId: this.filters.municipality
          ? this.filters.municipality.id
          : null,
        SchoolId: this.filters.school ? this.filters.school.id : null,
        PageIndex: this.pagination.currentPage,
        PageSize: this.pagination.pageSize,
      };

      await disciplineServices.markAllToChangeStatus(filterProperties, false);
      const { data } = await disciplineServices.existSelectionToChangeStatus(
        filterProperties
      );
      this.selecctionQuantity = data;
    },
  },
  computed: {
    showNotResults() {
      return (
        (this.isOREAdvancedFilter && !this.oreResults.length) ||
        (!this.isOREAdvancedFilter && !this.results.length)
      );
    },
    showAdvancedOREFilter() {
      return this.userHasPermissions(
        'academic.student.disciplinecertification.showadvance'
      );
    },
    isSubjected() {
      return this.currentStatusSearch == statusEnum.submited;
    },
    headerActionConfig() {
      return [
        {
          text: 'Generar Certificación',
          icon: 'fas fa-file-plus',
          variant: 'success',
          visible:
            this.isOREAdvancedFilter &&
            this.showAdvancedOREFilter &&
            !this.showCertificationPanel,
          click: this.openGenerateCertificationsPanel,
        },
        {
          text: 'Aprobar Certificaciones',
          icon: 'fas fa-check-circle',
          variant: 'outline-success',
          visible: this.selecctionQuantity,
          click: () => {
            this.approveSelectedCertification();
          },
        },
      ];
    },
    filtersHeader() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.collections.academicYears,
          value: this.filters.academicYear,
          placeholder: 'Año Académico',
          fieldName: 'description',
          fieldKey: 'id',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md mx-0 px-1',
          classContainer: 'w-100',
          error: this.messages['0675'] ? this.messages['0675'] : null,
          mapParentValue: this.filters.academicYear == null,
        },
        {
          name: 'region',
          component: 'CustomDropDown',
          options: this.collections.regions,
          value: this.filters.region,
          placeholder: 'Región',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md mx-0 px-1',
          classContainer: 'w-100',
          visible: !this.isOREAdvancedFilter,
          disabled: this.filters.academicYear == null || this.regionDisabled,
          mapParentValue: this.filters.region == null,
        },
        {
          name: 'center',
          component: 'CustomDropDown',
          placeholder: 'Centro',
          options: this.collections.centers,
          value: this.filters.center,
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md mx-0 px-1',
          classContainer: 'w-100',
          visible: this.isOREAdvancedFilter,
          disabled: this.filters.academicYear == null || this.centerDisabled,
          mapParentValue: this.filters.center == null,
        },
        {
          name: 'municipality',
          component: 'CustomDropDown',
          placeholder: 'Municipio',
          options: this.collections.municipalities,
          value: this.filters.municipality,
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md mx-0 px-1',
          classContainer: 'w-100',
          visible: !this.isOREAdvancedFilter,
          disabled:
            !this.filters.academicYear?.id ||
            !this.filters.region?.id ||
            (this.isOREAdvancedFilter && !this.filters.center?.id) ||
            this.municipalityDisabled,
          mapParentValue: this.filters.municipality == null,
        },
        {
          name: 'school',
          component: 'CustomDropDown',
          options: this.collections.schools,
          value: this.filters.school,
          placeholder: 'Escuela',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md mx-0 px-1',
          classContainer: 'w-100',
          visible: !this.isOREAdvancedFilter,
          disabled:
            this.filters.academicYear == null ||
            this.filters.municipality == null ||
            this.schoolDisabled,
          mapParentValue: this.filters.school == null,
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.collections.status,
          value: this.filters.status,
          placeholder: 'Estatus',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md mx-0 px-1',
          classContainer: 'w-100',
          mapParentValue: this.filters.status == null,
        },
      ];
    },
    isOREAdvancedFilter() {
      return this.switchFilter === SwitchCertificationFilter.CSEE;
    },
    schoolCertificationFilter() {
      return {
        SCHOOL: SwitchCertificationFilter.SCHOOL,
        CSEE: SwitchCertificationFilter.CSEE,
      };
    },
    getSwitchFilterStyles() {
      return (selectionFilter) =>
        this.switchFilter === selectionFilter
          ? 'orange text-white'
          : 'inactive inactive-gray';
    },
    showRegionLabel() {
      return !this.filteredByCenterFlag;
    },
    progressCounter() {
      return {
        complete: 0,
        completePercent: 0,
        pending: 0,
        pendingPercent: 0,
        total: 0,
        ...this.progress,
      };
    },
  },
  watch: {
    async isSelected(nw) {
      if (!this.isSubjected || this.isOREAdvancedFilter) return;
      let filterProperties = {
        AcademicYearId: this.filters.academicYear
          ? this.filters.academicYear.id
          : null,
        RegionId: this.filters.region ? this.filters.region.id : null,
        MunicipalityId: this.filters.municipality
          ? this.filters.municipality.id
          : null,
        SchoolId: this.filters.school ? this.filters.school.id : null,
        StatusId: statusEnum.submited,
        PageIndex: this.pagination.currentPage,
        PageSize: this.pagination.pageSize,
      };
      await disciplineServices.markAllToChangeStatus(filterProperties, nw);
      const { data } = await disciplineServices.existSelectionToChangeStatus(
        filterProperties
      );
      const dataResult = await disciplineServices.getDisciplineSearchData(
        filterProperties
      );
      this.results = dataResult.data.data;
      this.selecctionQuantity = data;
    },
    async switchFilter(nw) {
      this.resetByAcademicYear();

      const {
        data,
      } = await disciplineServices.getChildCountSearchInitialFilterValues();
      this.setFilters(data.filters);

      this.setAcademicYears(data.collections.academicYears);
      await this.onAcademicYearChanged();

      if (nw == this.schoolCertificationFilter.CSEE) {
        await this.setProgress();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$inactive-gray: #d9e5df;

.fsi {
  font-size: 36px;
  color: #cdcdcd;
}

.tsubhead-footer {
  color: #c9c9c9;
  font-size: 15px;
}
.inactive-gray {
  background-color: $inactive-gray !important;
}
.switch-switch-button {
  height: 39.55px;
}
.school-switch-button {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.csee-switch-button {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

@media only screen and (min-width: 1800px) {
  .align-end {
    position: relative;
    left: 40%;
  }

  .align-end-selected {
    position: relative;
    left: 17%;
  }
}
@media only screen and (min-width: 2400px) {
  .align-end {
    position: relative;
    left: 47%;
  }

  .align-end-selected {
    position: relative;
    left: 27%;
  }
}
.text-green {
  color: green;
}

.generate-certification-panel {
  margin-bottom: 33px;
  padding: 24px;
  gap: 16px;

  .generate-certification-filters {
    gap: 26px;

    &:deep(.filter-label) {
      font-weight: 600;
    }
  }

  &:deep(.dot) {
    padding: 15px;
  }

  &:deep(.circle-icon) {
    padding: 1px 0px 0px 1px;
  }
}
.container-progress {
  background-color: #f7f7f7;
  border-radius: 10px;
}
.container-progress-quantity {
  background-color: #ffffff;
  height: 100px;
  border-radius: 10px;
}
:deep(.custom-ddf) {
  .vs__selected-options {
    overflow: hidden;
    white-space: nowrap;

    .vs__selected {
      width: max-content;
    }
  }
}
</style>
